import type { ApplicationState } from "core/redux/reducers/rootReducer.ts";
import {
  CONSENSUS_HEIGHT,
  CONSERVATION_HEIGHT,
  LOGO_HEIGHT,
} from "sequenceAnalyser/components/Sequences/SequenceTableVisualisations/settings.ts";
import { elementToScale } from "sequenceAnalyser/utilities/screen/screen.ts";

export function calcVisualisationsHeight(
  visualisations: ApplicationState["sequenceAnalyser"]["settings"]["visualisations"],
  zoomLevel: number,
) {
  let visualisationsHeight = 0;
  if (visualisations.includes("consensus")) visualisationsHeight += CONSENSUS_HEIGHT;
  if (visualisations.includes("conservation")) visualisationsHeight += CONSERVATION_HEIGHT;
  if (visualisations.includes("logo")) visualisationsHeight += LOGO_HEIGHT;
  return elementToScale(visualisationsHeight, zoomLevel);
}
